// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__U0Gsw","slide":"slider_slide__ZZL4d"};